import { isUndefined } from '@aloft/toolkit-shared';
import { Select, SelectProps } from '@aloft/toolkit-sui';

import { Controller, useFormContext } from 'react-hook-form';

import { Td } from '../table.js';
import { FilterTableFieldName } from './types.js';

export function StringSelect({
  name,
  options,
  colSpan = 2,
  placeholder,
}: {
  name: FilterTableFieldName;
  options: SelectProps<string>['options'];
  colSpan?: number;
  placeholder?: string;
}) {
  const { control } = useFormContext();
  return (
    <Td colSpan={colSpan} type="editable">
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => {
          return (
            <Select
              id={name}
              options={options}
              size="sm"
              border={false}
              radius={false}
              isInvalid={fieldState.invalid}
              {...field}
              onChange={(value) => {
                if (isUndefined(value)) {
                  field.onChange('');
                } else {
                  field.onChange(value);
                }
              }}
              placeholder={placeholder}
            />
          );
        }}
      />
    </Td>
  );
}
